// extracted by mini-css-extract-plugin
export default {"Contact_box_info":"ContactsInfo_Contact_box_info__naApd"};